import * as Yup from "yup";
import { Button, FloatingLabel, Form, Modal, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import PropTypes from "prop-types";

import { guestFields } from "../helpers/event.js";

const schema = Yup.object().shape({
	firstName: Yup.string().required("First Name is required"),
	lastName: Yup.string().required("Last Name is required"),
	email: Yup.string().email("Invalid email"),
	phone: Yup.string(),
	type: Yup.string().required("Type is required"),
	gender: Yup.string(),
	isMinor: Yup.string()
});

const AddGuestForm = ({
	handleHide,
	initialValues,
	loading,
	registerGuest,
	roster
}) => (
	<Formik
		initialValues={initialValues}
		onSubmit={registerGuest}
		validateOnMount
		validationSchema={schema}
	>
		{({
			errors,
			handleBlur,
			handleChange,
			handleSubmit,
			touched,
			values
		}) => (
			<Form noValidate onSubmit={handleSubmit}>
				<Modal.Header closeButton>
					<Modal.Title>Add Family/Friend</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{guestFields().filter(({ attendee }) => attendee).
						map(({ label, name, options, type }) => type === "select"
							? (
								<FloatingLabel
									className="mb-3"
									controlId={name}
									key={name}
									label={label}
								>
									<Form.Select
										// eslint-disable-next-line react/jsx-no-leaked-render
										isInvalid={touched[name] && !!errors[name]}
										// eslint-disable-next-line react/jsx-no-leaked-render
										isValid={touched[name] && !errors[name]}
										name={name}
										onBlur={handleBlur}
										onChange={handleChange}
										placeholder={label}
										required
										value={values[name]}
									>
										<option value="">Select a type</option>
										{options.map((option) => <option key={option} value={option}>{option}</option>)}
									</Form.Select>
									{errors[name] ? <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback> : null}
								</FloatingLabel>
							)
							: (
								<FloatingLabel
									className="mb-3"
									controlId={name}
									key={name}
									label={label}
								>
									<Form.Control
										// eslint-disable-next-line react/jsx-no-leaked-render
										isInvalid={touched[name] && !!errors[name]}
										// eslint-disable-next-line react/jsx-no-leaked-render
										isValid={touched[name] && !errors[name]}
										name={name}
										onBlur={handleBlur}
										onChange={handleChange}
										placeholder={label}
										required
										type={type || "text"}
										value={values[name]}
									/>
									{errors[name] ? <Form.Control.Feedback type="invalid">{errors[name]}</Form.Control.Feedback> : null}
								</FloatingLabel>
							))}
					{roster
						? (
							<FloatingLabel
								className="mb-3"
								controlId="guestOf"
								key="guestOf"
								label="Guest Of"
							>
								<Form.Select
									// eslint-disable-next-line react/jsx-no-leaked-render
									isInvalid={touched.guestOf && !!errors.guestOf}
									// eslint-disable-next-line react/jsx-no-leaked-render
									isValid={touched.guestOf && !errors.guestOf}
									name="guestOf"
									onBlur={handleBlur}
									onChange={handleChange}
									placeholder="Guest Of"
									required
									value={values.guestOf}
								>
									<option value="0">Select an Attendee</option>
									{roster.map((attendee) => (
										<option
											key={attendee.userId}
											value={attendee.userId}
										>
											{attendee.title}
										</option>))}
								</Form.Select>
								{errors.guestOf ? <Form.Control.Feedback type="invalid">{errors.guestOf}</Form.Control.Feedback> : null}
							</FloatingLabel>
						) : null }
				</Modal.Body>
				<Modal.Footer className="d-flex justify-content-between">
					<Button onClick={handleHide} variant="outline-secondary">Cancel</Button>
					<Button
						disabled={loading}
						type="submit"
					>{loading ? <Spinner animation="border" size="sm" /> : "Add Family/Friend"}</Button>
				</Modal.Footer>
			</Form>
		)}
	</Formik>);

AddGuestForm.propTypes = {
	handleHide: PropTypes.func.isRequired,
	initialValues: PropTypes.shape({}),
	loading: PropTypes.bool,
	registerGuest: PropTypes.func.isRequired,
	roster: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string,
		userId: PropTypes.number
	}))
};

AddGuestForm.defaultProps = {
	initialValues: {},
	loading: false,
	roster: null
};

export default AddGuestForm;
